// example page => http://localhost:3000/svgLib

import React from 'react';


const svgLib = {
    livechat: (color, style) => (
        <svg
            style={{ ...style }}
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            width="48px"
            height="48px"
        >

            <path
                style={{ fill: color || '' }}
                d="M 12 2 C 7.593562 2 4 5.593562 4 10 L 4 11 L 4 11.902344 C 3.426291 12.449411 3 13.153146 3 14 C 3 15.241968 3.8575508 16.162904 4.9433594 16.613281 C 6.2443933 19.723094 8.8502365 22 12 22 L 15 22 L 15 20 L 12 20 C 9.7415517 20 7.6909574 18.299502 6.6601562 15.613281 L 6.4472656 15.0625 L 5.8613281 14.980469 C 5.3688308 14.912712 5 14.515121 5 14 C 5 13.615008 5.1944088 13.312973 5.4980469 13.138672 L 6 12.851562 L 6 12 L 6 11 C 6 10.43497 6.4349698 10 7 10 L 17 10 C 17.56503 10 18 10.43497 18 11 L 18 12 L 18 16 L 13.912109 16 A 1.5 1.5 0 0 0 12.5 15 A 1.5 1.5 0 0 0 11 16.5 A 1.5 1.5 0 0 0 12.392578 17.994141 A 1.0001 1.0001 0 0 0 12.5 18 L 19 18 L 20 18 C 21.1 18 22 17.1 22 16 L 22 14 C 22 12.9 21.1 12 20 12 L 20 11 L 20 10 C 20 5.593562 16.406438 2 12 2 z M 12 4 C 14.655588 4 16.890622 5.7073783 17.685547 8.0878906 C 17.464195 8.0350364 17.236504 8 17 8 L 7 8 C 6.7634959 8 6.5358051 8.0350364 6.3144531 8.0878906 C 7.1093779 5.7073783 9.3444124 4 12 4 z"
            />
        </svg>
    ),
    checkedFeature: (color, style) => (
        <svg
            style={{ ...style }}
            width="14"
            height="11"
            viewBox="0 0 14 11"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                style={{ fill: color || '' }}
                d="M5.00035 10.6134L0.860352 6.47336L2.74702 4.58669L5.00035 6.84669L11.587 0.253357L13.4737 2.14002L5.00035 10.6134Z"
                fill="black"
                fillOpacity="0.38"
            />
        </svg>
    ),
    checked: (color, style) => (
        <svg
            width="15"
            height="12"
            viewBox="0 0 15 12"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path

                d="M1 6.625L4.95652 11L14 1"
                stroke="white"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    ),

    arrowRight: (color, style) => (
        <svg
            viewBox="0 0 4 7"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            style={{ ...style }}
        >
            <path
                style={{ fill: color || '' }}
                d="M-3.27835e-08 5.32031L0.75 6.07031L3.78516 3.03516L0.75 4.44054e-07L-2.32558e-07 0.75L2.28516 3.03516L-3.27835e-08 5.32031Z"
                fill="#006CFF"
            />
        </svg>
    ),
    arrowLeft: (color, style) => (
        <svg
            viewBox="0 0 4 7"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            style={{ ...style, transform: 'scale(-1,1)' }}
        >
            <path
                style={{ fill: color || '' }}
                d="M-3.27835e-08 5.32031L0.75 6.07031L3.78516 3.03516L0.75 4.44054e-07L-2.32558e-07 0.75L2.28516 3.03516L-3.27835e-08 5.32031Z"
                fill="#006CFF"
            />
        </svg>
    ),
    arrowForward: (color, style) => (
        <svg
            viewBox="0 0 23 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            style={{ ...style }}
        >
            <path
                style={{ fill: color || '' }}
                d="M19.2757 8.50939L18.5346 10.5791C17.2403 6.87027 13.5013 4.37384 9.25646 4.72895C7.6389 4.86428 6.06934 5.4101 4.71688 6.30687C3.40589 7.17651 2.32165 8.3579 1.58148 9.72346L2.73752 10.2931C4.06615 7.84208 6.52921 6.23896 9.32624 6.00505C13.3657 5.66712 16.8719 8.3374 17.5763 12.0991L14.1914 11.0407L13.7542 12.2616L18.7491 13.8234L20.5134 8.89642L19.2757 8.50939Z"
                fill="#A6A6A6"
            />
        </svg>
    ),
    arrowBack: (color, style) => (
        <svg
            viewBox="0 0 23 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            style={{ ...style }}
        >
            <path
                style={{ fill: color || '' }}
                d="M3.64799 8.50939L4.38912 10.5791C5.68345 6.87027 9.42237 4.37384 13.6672 4.72895C15.2848 4.86428 16.8544 5.4101 18.2068 6.30687C19.5178 7.17651 20.6021 8.3579 21.3422 9.72346L20.1862 10.2931C18.8576 7.84208 16.3945 6.23896 13.5975 6.00505C9.558 5.66712 6.0518 8.3374 5.34739 12.0991L8.73231 11.0407L9.1695 12.2616L4.1746 13.8234L2.4103 8.89642L3.64799 8.50939Z"
                fill="#A6A6A6"
            />
        </svg>
    ),
    // pause: (color, style, fill) => (
    //     <svg
    //         fill={fill || 'none'}
    //         xmlns="http://www.w3.org/2000/svg"
    //         viewBox="0 0 24 24"
    //         style={{ ...style }}
    //     >
    //         <path
    //             d="M 3 3 L 3 21 L 10 21 L 10 3 Z M 14 3 L 14 21 L 21 21 L 21 3 Z"
    //             style={{ fill: color || '' }}
    //         />
    //     </svg>
    // ),
    docs: (color, style) => (
        <svg
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            style={{ ...style }}
        >
            <path
                style={{ fill: color || '' }}
                d="M 2 4 L 2 18 C 2 19.093063 2.9069372 20 4 20 L 10.587891 20 A 1.5 1.5 0 0 0 12 21 A 1.5 1.5 0 0 0 13.412109 20 L 20 20 C 21.093063 20 22 19.093063 22 18 L 22 4 L 15 4 C 13.789062 4 12.735556 4.5762461 12 5.4355469 C 11.264444 4.5762461 10.210938 4 9 4 L 2 4 z M 4 6 L 9 6 C 10.116666 6 11 6.8833339 11 8 L 13 8 C 13 6.8833339 13.883334 6 15 6 L 20 6 L 20 18 L 4 18 L 4 6 z M 15 9 L 15 11 L 17 11 L 17 9 L 15 9 z M 15 12 L 15 16 L 17 16 L 17 12 L 15 12 z"
            />
        </svg>
    ),
    // play: (color, style) => (
    //     <svg
    //         xmlns="http://www.w3.org/2000/svg"
    //         viewBox="0 0 24 24"
    //         style={{ ...style }}
    //     >
    //         <path d="M 4 2 L 4 22 L 21.3125 12 Z" style={{ fill: color || '' }} />
    //     </svg>
    // ),

    binoculars: (color, style) => (
        <svg
            viewBox="0 0 17 13"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            style={{ ...style }}
        >
            <path
                d="M16.9721 9.86314L16.9547 9.76808C16.9547 9.76152 16.9512 9.75496 16.9512 9.74841L16.3069 6.66707C16.2233 5.95574 15.673 5.3362 14.872 4.95267L14.5655 2.71378C14.5655 1.76316 13.4231 0.986267 12.0543 0.986267C10.6855 0.986267 9.38291 1.7566 9.38291 2.7105C9.38291 2.7564 9.3864 2.80557 9.39336 2.85146L9.41078 3.09403C9.13911 3.00225 8.82913 2.9498 8.50174 2.9498C8.17087 2.9498 7.86089 3.00225 7.58574 3.09731L7.60316 2.85146C7.61012 2.80557 7.6136 2.75967 7.6136 2.7105C7.6136 1.75988 6.30752 0.986267 4.94222 0.986267C3.57345 0.986267 2.43106 1.76316 2.43106 2.71378L2.12456 4.95267C1.3235 5.33292 0.773202 5.95574 0.689613 6.66707L0.0452776 9.74841C0.0452776 9.75496 0.0417947 9.76152 0.0417947 9.76808L0.0243802 9.86314C0.0104487 9.96148 0 10.0598 0 10.1614C0 11.6234 1.62651 12.8101 3.62917 12.8101C5.63184 12.8101 7.25835 11.6234 7.25835 10.1614V8.94857C7.61709 9.10592 8.04548 9.19442 8.50174 9.19442C8.958 9.19442 9.38291 9.10592 9.74165 8.95185V10.1614C9.74165 11.6234 11.3682 12.8101 13.3708 12.8101C15.37 12.8101 17 11.6234 17 10.1614C16.9965 10.0598 16.9861 9.96148 16.9721 9.86314ZM3.62917 11.8562C2.21164 11.8562 1.01352 11.0793 1.01352 10.1614C1.01352 9.24032 2.21164 8.4667 3.62917 8.4667C5.04671 8.4667 6.24483 9.24359 6.24483 10.1614C6.24483 11.0793 5.04671 11.8562 3.62917 11.8562ZM8.50174 8.35525C7.90617 8.35525 7.42204 8.03728 7.42204 7.6472C7.42204 7.25712 7.90617 6.93915 8.50174 6.93915C9.09732 6.93915 9.58144 7.25712 9.58144 7.6472C9.58144 8.03728 9.09732 8.35525 8.50174 8.35525ZM13.3673 11.8562C11.9498 11.8562 10.7517 11.0793 10.7517 10.1614C10.7517 9.24032 11.9498 8.4667 13.3673 8.4667C14.7849 8.4667 15.983 9.24359 15.983 10.1614C15.983 11.0793 14.7849 11.8562 13.3673 11.8562Z"
                style={{ fill: color || '' }}
            />
        </svg>
    ),
    link2: (color, style) => (
        <svg
            style={{ ...style }}
            viewBox="0 0 9 9"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M8.39733 0.602761C7.59381 -0.200763 6.28632 -0.200929 5.48269 0.602318L5.48285 0.602484L4.21139 1.87417L4.79829 2.46096L6.06998 1.189L6.06987 1.18889C6.55003 0.70955 7.33059 0.709827 7.81043 1.18966C8.29032 1.6695 8.29026 2.45045 7.81043 2.93045L5.90227 4.8385C5.66982 5.071 5.36074 5.19904 5.03196 5.19904C4.70318 5.19904 4.39404 5.071 4.16159 4.8385L3.57469 5.42534C3.96395 5.8146 4.48152 6.02901 5.03201 6.02901C5.58251 6.02901 6.10008 5.8146 6.48917 5.42534L8.39739 3.51729C9.20074 2.7136 9.20074 1.40612 8.39733 0.602761Z"
                style={{ fill: color || '' }}
            />
            <path
                d="M2.93037 7.8107C2.45037 8.29043 1.66947 8.29032 1.18958 7.81042C0.709694 7.33042 0.709694 6.54936 1.18953 6.06942L3.09747 4.16148C3.57747 3.68153 4.35842 3.68153 4.83831 4.16148L5.42527 3.57463C4.62163 2.77105 3.31415 2.77099 2.51062 3.57463L0.602573 5.48257C-0.200785 6.28615 -0.200785 7.59369 0.602628 8.39733C1.0045 8.79914 1.53225 9.00005 2.06011 9C2.58776 9 3.11551 8.7992 3.51716 8.3976L3.51727 8.39755L4.78901 7.12548L4.20205 6.53863L2.93037 7.8107Z"
                style={{ fill: color || '' }}
            />
        </svg>
    ),
    dashboard: (color, style) => (
        <svg
            style={{ ...style }}
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 20 16"
            fill="none"
        >
            <path
                d="M15 0C14.4492 0 14 0.449219 14 1V15C14 15.5508 14.4492 16 15 16H19C19.5508 16 20 15.5508 20 15V1C20 0.449219 19.5508 0 19 0H15ZM16 2H18V14H16V2ZM8 4C7.44922 4 7 4.44922 7 5V15C7 15.5508 7.44922 16 8 16H12C12.5508 16 13 15.5508 13 15V5C13 4.44922 12.5508 4 12 4H8ZM9 6H11V14H9V6ZM1 8C0.449219 8 0 8.44922 0 9V15C0 15.5508 0.449219 16 1 16H5C5.55078 16 6 15.5508 6 15V9C6 8.44922 5.55078 8 5 8H1ZM2 10H4V14H2V10Z"
                style={{ fill: color || '' }}
            />
        </svg>
    ),

    сonversations: (color, style) => (
        <svg
            style={{ ...style }}
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 20 19"
            fill="none"
        >
            <path
                d="M2 0C0.898438 0 0 0.898438 0 2V14L3 11H6V14C6 15.1016 6.89844 16 8 16H17L20 19V7C20 5.89844 19.1016 5 18 5H14V2C14 0.898438 13.1016 0 12 0H2ZM2 2H12V9H2V2ZM14 7H18V14H8V11H12C13.1016 11 14 10.1016 14 9V7Z"
                style={{ fill: color || '' }}
            />
        </svg>
    ),

    dialogflow: (color, style) => (
        <svg
            style={{ ...style }}
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 18 18"
            fill="none"
        >
            <path
                d="M0 17C0 17.5508 0.449219 18 1 18H5C5.55078 18 6 17.5508 6 17V13C6 12.4492 5.55078 12 5 12H4L4 5.8125C4.84375 5.50781 5.50781 4.84375 5.8125 4H12V5C12 5.55078 12.4492 6 13 6H14V12H13C12.4492 12 12 12.4492 12 13V17C12 17.5508 12.4492 18 13 18H17C17.5508 18 18 17.5508 18 17V13C18 12.4492 17.5508 12 17 12H16V6H17C17.5508 6 18 5.55078 18 5V1C18 0.449219 17.5508 0 17 0H13C12.4492 0 12 0.449219 12 1V2H5.8125C5.39453 0.84375 4.29297 0 3 0C1.35547 0 0 1.35547 0 3C0 4.29297 0.84375 5.39453 2 5.8125L2 12H1C0.449219 12 0 12.4492 0 13L0 17ZM2 16L2 14H4V16H2ZM2 3C2 2.4375 2.4375 2 3 2C3.5625 2 4 2.4375 4 3C4 3.5625 3.5625 4 3 4C2.4375 4 2 3.5625 2 3ZM14 16V14H16V16H14ZM14 4L14 2L16 2V4L14 4Z"
                style={{ fill: color || '' }}
            />
        </svg>
    ),

    settings: (color, style) => (
        <svg
            style={{ ...style }}
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 20 20"
            fill="none"
        >
            <path
                d="M7.66406 0L7.17578 2.52344C6.35156 2.83594 5.59375 3.26953 4.92969 3.8125L2.50781 2.97656L0.171875 7.02344L2.11328 8.70703C2.03906 9.16797 2 9.59375 2 10C2 10.4102 2.03906 10.832 2.11328 11.293L0.171875 12.9805L2.50781 17.0195L4.92969 16.1875C5.59375 16.7305 6.35156 17.1641 7.17578 17.4766L7.66406 20H12.332L12.8242 17.4766C13.6484 17.1641 14.4062 16.7305 15.0664 16.1875L17.4922 17.0195L19.8281 12.9805L17.8867 11.293C17.9609 10.832 18 10.4062 18 10C18 9.59375 17.9609 9.16797 17.8867 8.71094V8.70703L19.8281 7.01953L17.4922 2.97656L15.0703 3.8125C14.4062 3.26953 13.6484 2.83594 12.8242 2.52344L12.332 0H7.66406ZM9.3125 2H10.6875L11.0742 4L12.1172 4.39453C12.7461 4.63281 13.3125 4.95703 13.8008 5.35938L14.6641 6.06641L16.5859 5.40625L17.2695 6.59375L15.7344 7.92969L15.9102 9.02734V9.03125C15.9727 9.40234 16 9.71875 16 10C16 10.2812 15.9727 10.5977 15.9102 10.9688L15.7344 12.0703L17.2695 13.4062L16.582 14.5938L14.6641 13.9336L13.7969 14.6406C13.3086 15.043 12.7461 15.3672 12.1172 15.6055H12.1133L11.0742 16L10.6836 18H9.3125L8.92578 16L7.88281 15.6055C7.25391 15.3672 6.6875 15.043 6.19922 14.6406L5.33594 13.9336L3.41406 14.5938L2.72656 13.4062L4.26562 12.0703L4.08594 10.9727C4.02734 10.5977 4 10.2812 4 10C4 9.71875 4.02734 9.40234 4.08594 9.03125L4.26562 7.92969L2.72656 6.59375L3.41406 5.40625L5.33594 6.07031L6.19922 5.35938C6.6875 4.95703 7.25391 4.63281 7.88281 4.39453L8.92578 4L9.3125 2ZM10 6C7.80469 6 6 7.80469 6 10C6 12.1953 7.80469 14 10 14C12.1953 14 14 12.1953 14 10C14 7.80469 12.1953 6 10 6ZM10 8C11.1133 8 12 8.88672 12 10C12 11.1133 11.1133 12 10 12C8.88672 12 8 11.1133 8 10C8 8.88672 8.88672 8 10 8Z"
                style={{ fill: color || '' }}
            />
        </svg>
    ),

    marketing: (color, style) => (
        <svg
            style={{ ...style }}
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 20 18"
            fill="none"
        >
            <path
                d="M18 0L17 1.28516L4 6V12L6.45312 12.8906L6.16797 13.6875C5.95312 14.2891 6.26953 14.9492 6.87109 15.1602L9.04688 15.9336C9.64844 16.1484 10.3086 15.832 10.5234 15.2305L10.793 14.4648L17 16.7148L18 18H20V0H18ZM18 3.05078V14.9492L17.6836 14.832L6 10.5977V7.40234L17.6836 3.16406L18 3.05078ZM0 6V12H2V6H0Z"
                style={{ fill: color || '' }}
            />
        </svg>
    ),

    chevronDown: (color, style) => (
        <svg
            style={{ ...style }}
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 14 9"
            fill="none"
        >
            <path
                d="M2.42969 0.5L0.929688 2L7 8.07031L13.0703 2L11.5703 0.5L7 5.07031L2.42969 0.5Z"
                style={{ fill: color || '' }}
            />
        </svg>
    ),

    jingle: (color, style) => (
        <svg
            style={{ ...style }}
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 16 20"
            fill="none"
        >
            <path
                d="M8 0C7.17188 0 6.5 0.671875 6.5 1.5V2.19922C3.92188 2.87109 2 5.21875 2 8V12.8398L1.28125 15H0V17H6.26953C6.09375 17.3047 6 17.6484 6 18C6 19.1055 6.89453 20 8 20C9.10547 20 10 19.1055 10 18C10 17.6484 9.90625 17.3047 9.73047 17H16V15H14.7188L14 12.8398V8C14 5.21875 12.0781 2.87109 9.5 2.19922V1.5C9.5 0.671875 8.82812 0 8 0ZM8 4C10.2188 4 12 5.78125 12 8V13.1602L12.6094 15H3.39062L4 13.1602V8C4 5.78125 5.78125 4 8 4Z"
                style={{ fill: color || '' }}
            />
        </svg>
    ),

    student: (color, style) => (
        <svg
            style={{ ...style }}
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 22"
            fill="none"
        >
            <path
                d="M12 0L0 5L4 6.66797V11.7656C3.37109 12.3281 3 13.1406 3 14C3 15.2773 3.82422 16.3984 4.99219 16.8164C6.39453 20.0273 9.04297 22 12 22C14.957 22 17.6055 20.0273 19.0078 16.8164C20.1758 16.3984 21 15.2773 21 14C21 13.1406 20.6289 12.3281 20 11.7656V6.66797L22 5.83594V11H24V5L12 0ZM12 2.16797L18.8008 5L18 5.33203V8.17188C17.6875 8.0625 17.3516 8 17 8H7C6.64844 8 6.3125 8.0625 6 8.17188V5.33203L5.19922 5L12 2.16797ZM7 10H17C17.5508 10 18 10.4492 18 11V12.8516L18.5 13.1406C18.8125 13.3164 19 13.6406 19 14C19 14.4922 18.6289 14.9141 18.1367 14.9805L17.5508 15.0625L17.3438 15.6133C16.3047 18.3203 14.2578 20 12 20C9.74219 20 7.69922 18.3164 6.66016 15.6133L6.44922 15.0625L5.86328 14.9844C5.37109 14.9141 5 14.4922 5 14C5 13.6406 5.1875 13.3164 5.5 13.1406L6 12.8516V11C6 10.4492 6.44922 10 7 10Z"
                style={{ fill: color || '' }}
            />
        </svg>
    ),
    messenger: (color, style) => (
        <svg
            style={{ ...style }}
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 20 21"
            fill="none"
        >
            <path
                d="M10 0C4.48438 0 0 4.26172 0 9.5C0 12.0469 1.08984 14.4883 3 16.2695V20.6172L7.07812 18.5781C8.03906 18.8555 9.01953 19 10 19C15.5156 19 20 14.7383 20 9.5C20 4.26172 15.5156 0 10 0ZM10 2C14.4102 2 18 5.36328 18 9.5C18 13.6367 14.4102 17 10 17C9.21094 17 8.41406 16.8828 7.64062 16.6562L6.88672 16.4375L6.1875 16.7891L5 17.3828V15.4023L4.36328 14.8125C2.85937 13.4102 2 11.4727 2 9.5C2 5.36328 5.58984 2 10 2ZM9 7L4 12L8.5 10L11 12L16 7L11.5 9L9 7Z"
                style={{ fill: color || '' }}
            />
        </svg>
    ),
    folder: (color, style) => (
        <svg
            style={{ ...style }}
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 20 16"
            fill="none"
        >
            <path
                d="M2 0C0.90625 0 0 0.90625 0 2V14C0 15.0938 0.90625 16 2 16H18C19.0938 16 20 15.0938 20 14V4C20 2.90625 19.0938 2 18 2H10L8 0H2ZM2 2H7.17188L9.17188 4H18V14H2V2Z"
                style={{ fill: color || '' }}
            />
        </svg>
    ),
    pause: (color, style) => (
        <svg
            style={{ ...style }}
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 18 18"
            fill="none"
        >
            <path
                d="M2 0C0.90625 0 0 0.90625 0 2V16C0 17.0938 0.90625 18 2 18H16C17.0938 18 18 17.0938 18 16V2C18 0.90625 17.0938 0 16 0H2ZM2 2H16V16H2V2ZM6 5V13H8V5H6ZM10 5V13H12V5H10Z"
                style={{ fill: color || '' }}
            />
        </svg>
    ),
    telegram: (color, style) => (
        <svg
            style={{ ...style }}
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 20 18"
            fill="none"
        >
            <path
                d="M18.5742 0.0116971C18.2383 -0.0234589 17.8789 0.0273221 17.5156 0.171853C17.0664 0.347634 10.0156 3.31638 3.44141 6.08201L1.26953 6.99607C0.429688 7.33592 0.00390625 7.8906 0.00390625 8.6406C0.00390625 9.16013 0.226563 9.87107 1.28125 10.289L4.94531 11.7578C5.26563 12.707 6 14.9179 6.1875 15.5039C6.29688 15.8515 6.57422 16.7304 7.27344 16.9336C7.41797 16.9844 7.57031 17.0078 7.72266 17.0078C8.16406 17.0078 8.48438 16.8008 8.64062 16.6836L10.9688 14.7109L13.8008 17.3281C13.9102 17.4375 14.4883 18 15.2617 18C16.2305 18 16.9609 17.1953 17.1133 16.4179C17.1992 15.9883 19.9258 2.28513 19.9258 2.28904C20.1719 1.19138 19.7305 0.621072 19.4492 0.374978C19.207 0.167947 18.9062 0.0468531 18.5742 0.0116971ZM17.9102 2.17185C17.5312 4.06248 15.4766 14.3789 15.168 15.8633L11.0312 12.039L8.22266 14.4179L9 11.375C9 11.375 14.3633 5.94529 14.6875 5.63279C14.9453 5.37888 15 5.28904 15 5.2031C15 5.08592 14.9414 4.99998 14.8008 4.99998C14.6758 4.99998 14.5078 5.12107 14.418 5.17576C13.2734 5.8867 8.40234 8.66404 6.00781 10.0273L2.53125 8.6367L4.21875 7.92576C8.51953 6.11717 16.1758 2.89451 17.9102 2.17185Z"
                style={{ fill: color || '' }}
            />
        </svg>
    ),
    trash: (color, style) => (
        <svg
            style={{ ...style }}
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 16 20"
            fill="none"
        >
            <path
                d="M6 0L5 1H0V3H1V18C1 19.0938 1.90625 20 3 20H13C14.0938 20 15 19.0938 15 18V3H16V1H11L10 0H6ZM3 3H13V18H3V3ZM5.70703 6.29297L4.29297 7.70703L6.58594 10L4.29297 12.293L5.70703 13.707L8 11.4141L10.293 13.707L11.707 12.293L9.41406 10L11.707 7.70703L10.293 6.29297L8 8.58594L5.70703 6.29297Z"
                style={{ fill: color || '' }}
            />
        </svg>
    ),

    arrow: (color, style) => (
        <svg
            style={{ ...style }}
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 8 22"
            fill="none"
        >
            <path d="M3 0V18H0L4 22L8 18H5V0H3Z" style={{ fill: color || '' }} />
        </svg>
    ),

    cross: (color, style) => (
        <svg
            style={{ ...style }}
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 18 18"
            fill="none"
        >
            <path
                d="M1.70703 0.292969L0.292969 1.70703L7.58594 9L0.292969 16.293L1.70703 17.707L9 10.4141L16.293 17.707L17.707 16.293L10.4141 9L17.707 1.70703L16.293 0.292969L9 7.58594L1.70703 0.292969Z"
                style={{ fill: color || '' }}
            />
        </svg>
    ),

    pen: (color, style) => (
        <svg
            style={{ ...style }}
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 19 19"
            fill="none"
        >
            <path
                d="M15.4141 0C15.1562 0 14.9023 0.097656 14.707 0.292969L0 15V19H4L18.707 4.29297C19.0977 3.90234 19.0977 3.26953 18.707 2.87891L16.1211 0.292969C15.9258 0.097656 15.6719 0 15.4141 0ZM15.4141 2.41406L16.5859 3.58594L15.293 4.87891L14.1211 3.70703L15.4141 2.41406ZM12.707 5.12109L13.8789 6.29297L3.17188 17H2V15.8281L12.707 5.12109Z"
                style={{ fill: color || '' }}
            />
        </svg>
    ),
    evil: (color, style) => (
        <svg
            style={{ ...style }}
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 20 20"
            fill="none"
        >
            <path
                d="M10 0C4.48438 0 0 4.48438 0 10C0 15.5156 4.48438 20 10 20C15.5156 20 20 15.5156 20 10C20 4.48438 15.5156 0 10 0ZM5 7L9 9C9 9 8.59375 10 7 10C5.89453 10 5 9.10547 5 8V7ZM12.6562 14.9062C11.5938 15.1406 10.8125 14.8984 9.93359 14.5352C9.03516 14.168 8.01562 13.7656 7.20312 13.7656C6.39062 13.7656 4.92188 14.7344 5 14C5.375 12.3438 6.88672 12.0781 7.18359 12.0234C8.43359 11.8828 9.59375 12.2344 10.5312 12.5938C13.1484 13.5977 15.2344 11.8594 15 13C14.4219 13.8047 13.7148 14.6719 12.6562 14.9062ZM15 8C15 9.10547 14.1055 10 13 10C11.5625 10 11 9 11 9L15 7V8Z"
                style={{ fill: color || '' }}
            />
        </svg>
    ),
    usual: (color, style) => (
        <svg
            style={{ ...style }}
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 20 20"
            fill="none"
        >
            <path
                d="M10 0C4.48438 0 0 4.48438 0 10C0 15.5156 4.48438 20 10 20C15.5156 20 20 15.5156 20 10C20 4.48438 15.5156 0 10 0ZM4.5 7.98438C4.5 7.15625 5.17188 6.48438 6 6.48438C6.82812 6.48438 7.5 7.15625 7.5 7.98438C7.5 8.8125 6.82812 9.48438 6 9.48438C5.17188 9.48438 4.5 8.8125 4.5 7.98438ZM14 15H6V13H14V15ZM14 9.48438C13.1719 9.48438 12.5 8.8125 12.5 7.98438C12.5 7.15625 13.1719 6.48438 14 6.48438C14.8281 6.48438 15.5 7.15625 15.5 7.98438C15.5 8.8125 14.8281 9.48438 14 9.48438Z"
                style={{ fill: color || '' }}
            />
        </svg>
    ),
    smiling: (color, style) => (
        <svg
            style={{ ...style }}
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 20 20"
            fill="none"
        >
            <path
                d="M10 0C4.47656 0 0 4.47656 0 10C0 15.5234 4.47656 20 10 20C15.5234 20 20 15.5234 20 10C20 4.47656 15.5234 0 10 0ZM13.5 6C14.3281 6 15 6.67188 15 7.5C15 8.32812 14.3281 9 13.5 9C12.6719 9 12 8.32812 12 7.5C12 6.67188 12.6719 6 13.5 6ZM6.5 6C7.32812 6 8 6.67188 8 7.5C8 8.32812 7.32812 9 6.5 9C5.67188 9 5 8.32812 5 7.5C5 6.67188 5.67188 6 6.5 6ZM10 15.5C7.67188 15.5 5.69141 14.0391 4.89062 12H15.1094C14.3086 14.0391 12.3281 15.5 10 15.5Z"
                style={{ fill: color || '' }}
            />
        </svg>
    ),
    plus: (color, style) => (
        <svg
            style={{ ...style }}
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 18 18"
            fill="none"
        >
            <path
                d="M8 0V8H0V10H8V18H10V10H18V8H10V0H8Z"
                style={{ fill: color || '' }}
            />
        </svg>
    ),

    call: (color, style) => (
        <svg
            style={{ ...style }}
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 18 18"
            fill="none"
        >
            <path
                d="M1 0C0.5625 0 0 0.328125 0 1C0 5.53906 1.83984 9.875 4.96875 13.0312C8.125 16.1602 12.4609 18 17 18C17.6719 18 18 17.4375 18 17V13.4883C18 12.9453 17.5703 12.5 17.0234 12.4883C16.3945 12.4727 15.6016 12.4375 15.0977 12.3477C14.5586 12.25 13.9062 12.0664 13.4453 11.9219C13.3477 11.8945 13.2461 11.8789 13.1445 11.8789C12.8789 11.8789 12.6211 11.9844 12.4258 12.1758L10.2109 14.3789C8.67969 13.5742 7.44922 12.6328 6.41406 11.5898C5.36719 10.5508 4.42578 9.32031 3.61719 7.78906L5.82422 5.57031C6.08984 5.30469 6.1875 4.91406 6.07812 4.55469C5.93359 4.09375 5.74609 3.44141 5.65234 2.89844C5.5625 2.39844 5.52734 1.60547 5.51172 0.976563C5.5 0.429688 5.05469 0 4.50781 0H1ZM9 0V2C12.8672 2 16 5.13281 16 9H18C18 4.02734 13.9727 0 9 0ZM2.03125 2H3.55078C3.58203 2.50781 3.625 2.92188 3.67969 3.25C3.75 3.62891 3.85547 4.07031 3.99609 4.57422L2.79297 5.78516C2.37891 4.5625 2.12109 3.28906 2.03125 2ZM9 4V6C10.6562 6 12 7.34375 12 9H14C14 6.23828 11.7617 4 9 4ZM13.4258 14.0039C13.9297 14.1445 14.375 14.25 14.7539 14.3164C15.082 14.375 15.4922 14.418 16 14.4492V15.9688C14.7109 15.8789 13.4375 15.6172 12.2148 15.207L13.4258 14.0039Z"
                style={{ fill: color || '' }}
            />
        </svg>
    ),

    node: (color, style) => (
        <svg
            style={{ ...style }}
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 18 20"
            fill="none"
        >
            <path
                d="M15 0C13.3555 0 12 1.35547 12 3C12 3.19141 12.0234 3.37891 12.0586 3.55859L4.92188 7.71875C4.39844 7.27734 3.73047 7 3 7C1.35547 7 0 8.35547 0 10C0 11.6445 1.35547 13 3 13C3.73047 13 4.39844 12.7227 4.92188 12.2812L12.0586 16.4375C12.0234 16.6211 12 16.8086 12 17C12 18.6445 13.3555 20 15 20C16.6445 20 18 18.6445 18 17C18 15.3555 16.6445 14 15 14C14.2656 14 13.6016 14.2812 13.0781 14.7227L5.94531 10.5586C5.97656 10.3789 6 10.1914 6 10C6 9.80859 5.97656 9.62109 5.94531 9.44141L13.0781 5.28125C13.6016 5.72266 14.2695 6 15 6C16.6445 6 18 4.64453 18 3C18 1.35547 16.6445 0 15 0ZM15 2C15.5625 2 16 2.4375 16 3C16 3.5625 15.5625 4 15 4C14.4375 4 14 3.5625 14 3C14 2.4375 14.4375 2 15 2ZM3 9C3.5625 9 4 9.4375 4 10C4 10.5625 3.5625 11 3 11C2.4375 11 2 10.5625 2 10C2 9.4375 2.4375 9 3 9ZM15 16C15.5625 16 16 16.4375 16 17C16 17.5625 15.5625 18 15 18C14.4375 18 14 17.5625 14 17C14 16.4375 14.4375 16 15 16Z"
                style={{ fill: color || '' }}
            />
        </svg>
    ),

    link: (color, style) => (
        <svg
            style={{ ...style }}
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 22 10"
            fill="none"
        >
            <path
                d="M5 0C2.23828 0 0 2.23828 0 5C0 7.76172 2.23828 10 5 10H9V8H5C3.34375 8 2 6.65625 2 5C2 3.34375 3.34375 2 5 2H9V0H5ZM13 0V2H17C18.6562 2 20 3.34375 20 5C20 6.65625 18.6562 8 17 8H13V10H17C19.7617 10 22 7.76172 22 5C22 2.23828 19.7617 0 17 0H13ZM6 4V6H16V4H6Z"
                style={{ fill: color || '' }}
            />
        </svg>
    ),
    enter: (color, style) => (
        <svg
            style={{ ...style }}
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 21 20"
            fill="none"
        >
            <path
                d="M10 0C4.48438 0 0 4.48438 0 10C0 15.5156 4.48438 20 10 20C13.2617 20 16.1523 18.4219 17.9805 16H15.2734C13.8633 17.2422 12.0195 18 10 18C5.58984 18 2 14.4102 2 10C2 5.58984 5.58984 2 10 2C12.0195 2 13.8633 2.75781 15.2734 4H17.9805C16.1523 1.57812 13.2617 0 10 0ZM17 6V9H10V11H17V14L21 10L17 6Z"
                style={{ fill: color || '' }}
            />
        </svg>
    ),
    appliance: (color, style) => (
        <svg
            style={{ ...style }}
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 10"
            fill="none"
        >
            <path
                d="M2 0C0.90625 0 0 0.90625 0 2V8C0 9.09375 0.90625 10 2 10H22C23.0938 10 24 9.09375 24 8V2C24 0.90625 23.0938 0 22 0H2ZM2 2H22V8H2V2ZM7 4V6H9V4H7ZM11 4V6H13V4H11ZM15 4V6H17V4H15Z"
                style={{ fill: color || '' }}
            />
        </svg>
    ),
    add: (color, style) => (
        <svg
            style={{ ...style }}
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 20 20"
            fill="none"
        >
            <path
                d="M4 0V2H18V16H20V2C20 0.894531 19.1055 0 18 0H4ZM2 4C0.894531 4 0 4.89453 0 6V18C0 19.1055 0.894531 20 2 20H14C15.1055 20 16 19.1055 16 18V6C16 4.89453 15.1055 4 14 4H2ZM2 6H14V18H2V6ZM7 8V11H4V13H7V16H9V13H12V11H9V8H7Z"
                style={{ fill: color || '' }}
            />
        </svg>
    ),
    burger: (color, style) => (
        <svg
            style={{ ...style }}
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 20 14"
            fill="none"
        >
            <path
                d="M0 0V2H20V0H0ZM0 6V8H20V6H0ZM0 12V14H20V12H0Z"
                style={{ fill: color || '' }}
            />
        </svg>
    ),
    person: (color, style) => (
        <svg
            style={{ ...style }}
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 20 20"
            fill="none"
        >
            <path
                d="M10 0C4.47656 0 0 4.47656 0 10C0 15.5234 4.47656 20 10 20C15.5234 20 20 15.5234 20 10C20 4.47656 15.5234 0 10 0ZM10 2C14.418 2 18 5.58203 18 10C18 11.5977 17.5273 13.082 16.7188 14.3281L15.9492 13.7344C14.3984 12.5391 11.5352 12 10 12C8.46484 12 5.60156 12.5391 4.05078 13.7344L3.28125 14.332C2.47266 13.082 2 11.5977 2 10C2 5.58203 5.58203 2 10 2ZM10 3.75C8.20703 3.75 6.75 5.20703 6.75 7C6.75 8.79297 8.20703 10.25 10 10.25C11.793 10.25 13.25 8.79297 13.25 7C13.25 5.20703 11.793 3.75 10 3.75ZM10 5.75C10.6875 5.75 11.25 6.3125 11.25 7C11.25 7.6875 10.6875 8.25 10 8.25C9.3125 8.25 8.75 7.6875 8.75 7C8.75 6.3125 9.3125 5.75 10 5.75ZM10 14C13.1016 14 14.7695 15.168 15.5469 15.7539C14.1094 17.1406 12.1562 18 10 18C7.84375 18 5.89062 17.1406 4.45312 15.7539C5.23047 15.168 6.89844 14 10 14ZM4.05469 15.3398C4.17578 15.4727 4.29688 15.6055 4.42578 15.7305C4.29688 15.6055 4.17578 15.4727 4.05469 15.3398ZM15.9102 15.375C15.8008 15.4961 15.6914 15.6172 15.5781 15.7305C15.6914 15.6172 15.8008 15.4961 15.9102 15.375Z"
                style={{ fill: color || '' }}
            />
        </svg>
    ),
    message: (color, style) => (
        <svg
            style={{ ...style }}
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 20 20"
            fill="none"
        >
            <path
                d="M2 0C0.910156 0 0 0.90625 0 2V14C0 15.0938 0.910156 16 2 16H16L20 20L19.9883 2C19.9922 0.90625 19.082 0 17.9883 0H2ZM2 2H17.9883L18 15.168L16.8281 14H2V2ZM5 5V7H15V5H5ZM5 9V11H12V9H5Z"
                style={{ fill: color || '' }}
            />
        </svg>
    ),
    basket: (color, style) => (
        <svg
            style={{ ...style }}
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 20 21"
            fill="none"
        >
            <path
                d="M3.41016 0L0 0.019531L0.011719 2.01953L2.08203 2.00781L5.375 9.91016L4.17578 11.8281C3.77734 12.4688 3.75781 13.2773 4.12109 13.9375C4.48828 14.5938 5.18359 15.0039 5.9375 15.0039H17.9961V13.0039H5.9375L5.87109 12.8867L7.05078 11.0039H14.5156C15.2461 11.0039 15.9141 10.6094 16.2656 9.97266L19.8711 3.48828C20.043 3.17969 20.0391 2.80078 19.8555 2.49609C19.6758 2.19141 19.3477 2.00391 18.9961 2.00391H4.24609L3.41016 0ZM5.07812 4.00391H17.293L14.5156 9.00391H7.16016L5.07812 4.00391ZM5.99609 16.0039C4.89062 16.0039 3.99609 16.8984 3.99609 18.0039C3.99609 19.1094 4.89062 20.0039 5.99609 20.0039C7.10156 20.0039 7.99609 19.1094 7.99609 18.0039C7.99609 16.8984 7.10156 16.0039 5.99609 16.0039ZM15.9961 16.0039C14.8906 16.0039 13.9961 16.8984 13.9961 18.0039C13.9961 19.1094 14.8906 20.0039 15.9961 20.0039C17.1016 20.0039 17.9961 19.1094 17.9961 18.0039C17.9961 16.8984 17.1016 16.0039 15.9961 16.0039Z"
                style={{ fill: color || '' }}
            />
        </svg>
    ),
    lamp: (color, style) => (
        <svg
            style={{ ...style }}
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 23"
            fill="none"
        >
            <path
                d="M12 0C11.4492 0 11 0.449219 11 1C11 1.55078 11.4492 2 12 2C12.5508 2 13 1.55078 13 1C13 0.449219 12.5508 0 12 0ZM4.22266 3.22266C3.67187 3.22266 3.22266 3.67187 3.22266 4.22266C3.22266 4.77344 3.67187 5.22266 4.22266 5.22266C4.77344 5.22266 5.22266 4.77344 5.22266 4.22266C5.22266 3.67187 4.77344 3.22266 4.22266 3.22266ZM19.7773 3.22266C19.2266 3.22266 18.7773 3.67187 18.7773 4.22266C18.7773 4.77344 19.2266 5.22266 19.7773 5.22266C20.3281 5.22266 20.7773 4.77344 20.7773 4.22266C20.7773 3.67187 20.3281 3.22266 19.7773 3.22266ZM12 5C8.14062 5 5 8.14062 5 12C5 14.7148 6.58203 17.1719 9 18.3164V21C9 22.1016 9.89844 23 11 23H13C14.1016 23 15 22.1016 15 21V18.3164C17.418 17.1719 19 14.7148 19 12C19 8.14062 15.8594 5 12 5ZM12 7C14.7578 7 17 9.24219 17 12C17 14.1094 15.6602 16.0039 13.668 16.707L13 16.9414V21H11V16.9414L10.332 16.707C8.33984 16.0039 7 14.1094 7 12C7 9.24219 9.24219 7 12 7ZM1 11C0.449219 11 0 11.4492 0 12C0 12.5508 0.449219 13 1 13C1.55078 13 2 12.5508 2 12C2 11.4492 1.55078 11 1 11ZM23 11C22.4492 11 22 11.4492 22 12C22 12.5508 22.4492 13 23 13C23.5508 13 24 12.5508 24 12C24 11.4492 23.5508 11 23 11ZM4.22266 18.7773C3.67187 18.7773 3.22266 19.2266 3.22266 19.7773C3.22266 20.3281 3.67187 20.7773 4.22266 20.7773C4.77344 20.7773 5.22266 20.3281 5.22266 19.7773C5.22266 19.2266 4.77344 18.7773 4.22266 18.7773ZM19.7773 18.7773C19.2266 18.7773 18.7773 19.2266 18.7773 19.7773C18.7773 20.3281 19.2266 20.7773 19.7773 20.7773C20.3281 20.7773 20.7773 20.3281 20.7773 19.7773C20.7773 19.2266 20.3281 18.7773 19.7773 18.7773Z"
                style={{ fill: color || '' }}
            />
        </svg>
    ),
    question: (color, style) => (
        <svg
            style={{ ...style }}
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 20 20"
            fill="none"
        >
            <path
                d="M10 0C4.48828 0 0 4.48828 0 10C0 15.5117 4.48828 20 10 20C15.5117 20 20 15.5117 20 10C20 4.48828 15.5117 0 10 0ZM10 2C14.4297 2 18 5.57031 18 10C18 14.4297 14.4297 18 10 18C5.57031 18 2 14.4297 2 10C2 5.57031 5.57031 2 10 2ZM10 4C7.78906 4 6 5.78906 6 8H8C8 6.89844 8.89844 6 10 6C11.1016 6 12 6.89844 12 8C12 10 9 10.3672 9 13H11C11 11.3477 14 10.5 14 8C14 5.78906 12.2109 4 10 4ZM9 14V16H11V14H9Z"
                style={{ fill: color || '' }}
            />
        </svg>
    ),
    gears: (color, style) => (
        <svg
            style={{ ...style }}
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 21 20"
            fill="none"
        >
            <path
                d="M15.0625 0C14.9336 0 14.8281 0.097656 14.8125 0.226563L14.6953 1.23438C14.2109 1.40625 13.7734 1.66016 13.3945 1.98828L12.457 1.58594C12.3398 1.53125 12.2031 1.57812 12.1406 1.6875L11.2031 3.3125C11.1367 3.42188 11.168 3.5625 11.2695 3.64062L12.0781 4.24219C12.0312 4.48828 12 4.73828 12 5C12 5.26172 12.0312 5.51172 12.0781 5.75781L11.2695 6.35938C11.168 6.43359 11.1367 6.57812 11.2031 6.6875L12.1406 8.3125C12.2031 8.42188 12.3398 8.46875 12.457 8.41797L13.3945 8.01172C13.7734 8.33984 14.2109 8.59375 14.6953 8.76562L14.8125 9.77734C14.8281 9.90234 14.9336 10 15.0625 10H16.9375C17.0664 10 17.1719 9.90234 17.1875 9.77734L17.3047 8.76562C17.7891 8.59375 18.2266 8.33984 18.6094 8.01172L19.543 8.41406C19.6601 8.46484 19.7969 8.42188 19.8594 8.30859L20.7969 6.6875C20.8633 6.57812 20.832 6.43359 20.7305 6.35938L19.9219 5.75781C19.9726 5.51172 20 5.25781 20 5C20 4.73828 19.9687 4.48828 19.9219 4.24219L20.7305 3.64062C20.832 3.56641 20.8633 3.42188 20.7969 3.3125L19.8594 1.6875C19.7969 1.57812 19.6601 1.53125 19.543 1.58203L18.6055 1.98828C18.2266 1.66016 17.7891 1.40625 17.3047 1.23438L17.1875 0.226563C17.1719 0.097656 17.0664 0 16.9375 0H15.0625ZM16 3C17.1055 3 18 3.89453 18 5C18 6.10547 17.1055 7 16 7C14.8945 7 14 6.10547 14 5C14 3.89453 14.8945 3 16 3ZM6.06249 7C5.93359 7 5.82812 7.09766 5.81249 7.22656L5.64062 8.71094C4.83202 8.94141 4.10156 9.35156 3.51562 9.92188L2.15624 9.33594C2.03906 9.28516 1.90234 9.32812 1.83984 9.44141L0.902336 11.0625C0.83593 11.1719 0.86718 11.3164 0.968742 11.3906L2.16796 12.2812C2.07031 12.6719 1.99999 13.0781 1.99999 13.5C1.99999 13.9219 2.07031 14.3281 2.16796 14.7188L0.968742 15.6094C0.86718 15.6836 0.839836 15.8281 0.902336 15.9375L1.83984 17.5625C1.90234 17.6719 2.03906 17.7188 2.15624 17.668L3.51562 17.0781C4.10156 17.6484 4.83202 18.0586 5.64062 18.2891L5.81249 19.7773C5.82812 19.9023 5.93359 20 6.06249 20H7.93749C8.0664 20 8.17187 19.9023 8.18749 19.7773L8.35937 18.2891C9.16796 18.0586 9.89843 17.6484 10.4844 17.0781L11.8437 17.6641C11.9609 17.7148 12.0976 17.6719 12.1601 17.5586L13.0976 15.9375C13.1641 15.8281 13.1328 15.6836 13.0312 15.6094L11.832 14.7188C11.9297 14.3281 12 13.9219 12 13.5C12 13.0781 11.9297 12.6719 11.832 12.2812L13.0312 11.3906C13.1328 11.3164 13.1601 11.1719 13.0976 11.0625L12.1601 9.4375C12.0976 9.32812 11.9609 9.28125 11.8437 9.33203L10.4844 9.92188C9.89843 9.35156 9.16796 8.94141 8.35937 8.71094L8.18749 7.22656C8.17187 7.09766 8.0664 7 7.93749 7H6.06249ZM6.99999 10.5C8.65624 10.5 9.99999 11.8438 9.99999 13.5C9.99999 15.1562 8.65624 16.5 6.99999 16.5C5.34374 16.5 3.99999 15.1562 3.99999 13.5C3.99999 11.8438 5.34374 10.5 6.99999 10.5ZM6.99999 12.5C6.44921 12.5 5.99999 12.9492 5.99999 13.5C5.99999 14.0508 6.44921 14.5 6.99999 14.5C7.55077 14.5 7.99999 14.0508 7.99999 13.5C7.99999 12.9492 7.55077 12.5 6.99999 12.5Z"
                style={{ fill: color || '' }}
            />
        </svg>
    ),
    information: (color, style) => (
        <svg
            style={{ ...style }}
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 20 20"
            fill="none"
        >
            <path
                d="M10 0C4.48828 0 0 4.48828 0 10C0 15.5117 4.48828 20 10 20C15.5117 20 20 15.5117 20 10C20 4.48828 15.5117 0 10 0ZM10 2C14.4297 2 18 5.57031 18 10C18 14.4297 14.4297 18 10 18C5.57031 18 2 14.4297 2 10C2 5.57031 5.57031 2 10 2ZM9 5V7H11V5H9ZM9 9V15H11V9H9Z"
                style={{ fill: color || '' }}
            />
        </svg>
    ),
    camera: (color, style) => (
        <svg
            style={{ ...style }}
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 20 18"
            fill="none"
        >
            <path
                d="M13 0L7 0.00390601L5.16406 2H2C0.898438 2 0 2.89844 0 4V16C0 17.1016 0.898438 18 2 18H18C19.1016 18 20 17.1016 20 16V4C20 2.89844 19.1016 2 18 2H14.8438L13 0ZM12.1211 2L13.9688 4H18V16H2V4H6.04297L7.87891 2H12.1211ZM10 5C7.23828 5 5 7.23828 5 10C5 12.7617 7.23828 15 10 15C12.7617 15 15 12.7617 15 10C15 7.23828 12.7617 5 10 5ZM10 7C11.6562 7 13 8.34375 13 10C13 11.6562 11.6562 13 10 13C8.34375 13 7 11.6562 7 10C7 8.34375 8.34375 7 10 7Z"
                style={{ fill: color || '' }}
            />
        </svg>
    ),
    refresh: (color, style) => (
        <svg
            style={{ ...style }}
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 18 18"
            fill="none"
        >
            <path
                d="M9 0C4.03516 0 0 4.03906 0 9H2C2 5.14062 5.14062 2 9 2C11.1836 2 13.125 3.01562 14.4062 4.59375L12 7H18V1L15.832 3.16406C14.1836 1.23047 11.7383 0 9 0ZM16 9C16 12.8594 12.8594 16 9 16C6.81641 16 4.875 14.9844 3.59375 13.4062L6 11H0V17L2.16406 14.832C3.81641 16.7695 6.26172 18 9 18C13.9648 18 18 13.9648 18 9H16Z"
                style={{ fill: color || '' }}
            />
        </svg>
    ),
    copy: (color, style) => (
        <svg
            style={{ ...style }}
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 20 20"
            fill="none"
        >
            <path
                d="M2 0C0.894531 0 0 0.894531 0 2V16H2V2H16V0H2ZM6 4C4.89453 4 4 4.89453 4 6V18C4 19.1055 4.89453 20 6 20H18C19.1055 20 20 19.1055 20 18V6C20 4.89453 19.1055 4 18 4H6ZM6 6H18V18H6V6Z"
                style={{ fill: color || '' }}
            />
        </svg>
    ),
    eye: (color, style) => (
        <svg
            style={{ ...style }}
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 22 16"
            fill="none"
        >
            <path
                d="M11 0C3 0 0 8 0 8C0 8 3 16 11 16C19 16 22 8 22 8C22 8 19 0 11 0ZM11 2C16.2773 2 18.9453 6.26562 19.8086 7.99609C18.9453 9.71484 16.2539 14 11 14C5.72266 14 3.05469 9.73438 2.19141 8.00391C3.05859 6.28516 5.74609 2 11 2ZM11 4C8.78906 4 7 5.78906 7 8C7 10.2109 8.78906 12 11 12C13.2109 12 15 10.2109 15 8C15 5.78906 13.2109 4 11 4ZM11 6C12.1055 6 13 6.89453 13 8C13 9.10547 12.1055 10 11 10C9.89453 10 9 9.10547 9 8C9 6.89453 9.89453 6 11 6Z"
                style={{ fill: color || '' }}
            />
        </svg>
    ),
    play: (color, style) => (
        <svg
            style={{ ...style }}
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 18 18"
            fill="none"
        >
            <path
                d="M2 0C0.90625 0 0 0.90625 0 2V16C0 17.0938 0.90625 18 2 18H16C17.0938 18 18 17.0938 18 16V2C18 0.90625 17.0938 0 16 0H2ZM2 2H16V16H2V2ZM6 5V13L13 9L6 5Z"
                style={{ fill: color || '' }}
            />
        </svg>
    ),
    funnel: (color, style) => (
        <svg
            style={{ ...style }}
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 18 18"
            fill="none"
        >
            <path
                d="M0 0V2H1L6 10V18H12V10L17 2H18V0H0ZM3.35938 2H14.6406L10 9.42578V16H8V9.42578L3.35938 2Z"
                style={{ fill: color || '' }}
            />
        </svg>
    ),
    back: (color, style) => (
        <svg
            style={{ ...style }}
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 22 18"
            fill="none"
        >
            <path
                d="M6 0L0 6L6 12V7H15.5C17.9805 7 20 9.01953 20 11.5C20 13.9805 17.9805 16 15.5 16H14V18H15.5C19.0703 18 22 15.0703 22 11.5C22 7.92969 19.0703 5 15.5 5H6V0ZM2 16V18H4V16H2ZM6 16V18H8V16H6ZM10 16V18H12V16H10Z"
                style={{ fill: color || '' }}
            />
        </svg>
    ),
    br: (color, style) => (
        <svg
            style={{ ...style }}
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 18 18"
            fill="none"
        >
            <path
                d="M16 0V9C16 10.668 14.668 12 13 12H5V8L0 13L5 18V14H13C15.75 14 18 11.75 18 9V0H16Z"
                style={{ fill: color || '' }}
            />
        </svg>
    ),
    quotes: (color, style) => (
        <svg
            style={{ ...style }}
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 20 20"
            fill="none"
        >
            <path
                d="M2 0C0.898438 0 0.00781298 0.898438 0.00781298 2L0 14C0 15.1016 0.894531 16 2 16H4V20L8 16H18C19.0977 16 20 15.1016 20 14V2C20 0.898438 19.0977 0 18 0H2ZM2 2H18V14H2V2ZM5 5V9H7L5 12H7L9 9V5H5ZM11 5V9H13L11 12H13L15 9V5H11Z"
                style={{ fill: color || '' }}
            />
        </svg>
    ),
    check: (color, style) => (
        <svg
            style={{ ...style }}
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 19 15"
            fill="none"
        >
            <path
                d="M17.293 0.292969L6 11.5859L1.70703 7.29297L0.292969 8.70703L6 14.4141L18.707 1.70703L17.293 0.292969Z"
                style={{ fill: color || '' }}
            />
        </svg>
    ),
    error: (color, style) => (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 26 26"
            style={{ ...style, fill: color || '' }}
        >
            <path d="M 13 1 C 6.382813 1 1 6.382813 1 13 C 1 19.617188 6.382813 25 13 25 C 19.617188 25 25 19.617188 25 13 C 25 6.382813 19.617188 1 13 1 Z M 13 3 C 18.535156 3 23 7.464844 23 13 C 23 15.40625 22.160156 17.621094 20.75 19.34375 L 6.65625 5.25 C 8.378906 3.839844 10.59375 3 13 3 Z M 5.25 6.65625 L 19.34375 20.75 C 17.621094 22.160156 15.40625 23 13 23 C 7.464844 23 3 18.535156 3 13 C 3 10.59375 3.839844 8.378906 5.25 6.65625 Z" />
        </svg>
    ),
    errorTwo: (color, style) => (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            style={{ ...style, fill: color || '' }}
        >
            <path d="M 12 0 C 5.371094 0 0 5.371094 0 12 C 0 18.628906 5.371094 24 12 24 C 18.628906 24 24 18.628906 24 12 C 24 5.371094 18.628906 0 12 0 Z M 12 2 C 17.523438 2 22 6.476563 22 12 C 22 17.523438 17.523438 22 12 22 C 6.476563 22 2 17.523438 2 12 C 2 6.476563 6.476563 2 12 2 Z M 11 6 L 11 14 L 13 14 L 13 6 Z M 11 16 L 11 18 L 13 18 L 13 16 Z" />
        </svg>
    ),
    download: (color, style) => (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            style={{ ...style, fill: color || '' }}
            viewBox="0 0 20 20"
            fill="none"
        >
            <path
                d="M9 0V2H11V0H9ZM9 4V12.5859L5.70703 9.29297L4.29297 10.707L10 16.4141L15.707 10.707L14.293 9.29297L11 12.5859V4H9ZM0 15V18C0 19.0938 0.90625 20 2 20H18C19.0938 20 20 19.0938 20 18V15H18V18H2V15H0Z"
                style={{ fill: color || '' }}
            />
        </svg>
    ),
    plusZoom: (color, style) => (
        <svg
            width="12"
            height="12"
            viewBox="0 0 12 12"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            style={{ ...style }}
        >
            <path
                style={{ fill: color || '' }}
                d="M11.5312 5.53125H6.46875V0.46875C6.46875 0.209859 6.25889 0 6 0C5.74111 0 5.53125 0.209859 5.53125 0.46875V5.53125H0.46875C0.209859 5.53125 0 5.74111 0 6C0 6.25889 0.209859 6.46875 0.46875 6.46875H5.53125V11.5312C5.53125 11.7901 5.74111 12 6 12C6.25889 12 6.46875 11.7901 6.46875 11.5312V6.46875H11.5312C11.7901 6.46875 12 6.25889 12 6C12 5.74111 11.7901 5.53125 11.5312 5.53125Z"
                fill="#999999"
            />
        </svg>
    ),
    minusZoom: (color, style) => (
        <svg
            style={{ ...style }}
            width="10"
            height="1"
            viewBox="0 0 10 1"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                style={{ fill: color || '' }}
                d="M5.39062 0H9.60938C9.82512 0 10 0.22385 10 0.5C10 0.77615 9.82512 1 9.60938 1H5.39062H4.60938H0.390625C0.174883 1 0 0.77615 0 0.5C0 0.22385 0.174883 0 0.390625 0H4.60938H5.39062Z"
                fill="#999999"
            />
        </svg>
    ),
    home: (color, style) => (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            style={{ ...style, fill: color || '' }}
        >
            <path
                style={{ fill: color || '' }}
                d="M 12 2 A 1 1 0 0 0 11.289062 2.296875 L 1.203125 11.097656 A 0.5 0.5 0 0 0 1 11.5 A 0.5 0.5 0 0 0 1.5 12 L 4 12 L 4 20 C 4 20.552 4.448 21 5 21 L 9 21 C 9.552 21 10 20.552 10 20 L 10 14 L 14 14 L 14 20 C 14 20.552 14.448 21 15 21 L 19 21 C 19.552 21 20 20.552 20 20 L 20 12 L 22.5 12 A 0.5 0.5 0 0 0 23 11.5 A 0.5 0.5 0 0 0 22.796875 11.097656 L 12.716797 2.3027344 A 1 1 0 0 0 12.710938 2.296875 A 1 1 0 0 0 12 2 z"
            />
        </svg>
    ),
    undo: (color, style) => (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            style={{ ...style, fill: color || '' }}
        >
            <path d="M 2.5 8 C 2.372 8 2.2439844 8.0489844 2.1464844 8.1464844 C 2.0484844 8.2434844 2 8.372 2 8.5 L 2 15 A 1 1 0 0 0 3 16 L 9.5 16 C 9.628 16 9.7555156 15.950516 9.8535156 15.853516 C 10.048516 15.658516 10.048516 15.341484 9.8535156 15.146484 L 7.2207031 12.513672 C 8.6282801 11.265495 10.470063 10.5 12.5 10.5 C 15.649 10.5 18.367875 12.32275 19.671875 14.96875 C 19.947875 15.52875 20.588641 15.803469 21.181641 15.605469 C 21.890641 15.369469 22.250875 14.559672 21.921875 13.888672 C 20.215875 10.403672 16.643 8 12.5 8 C 9.7794954 8 7.3175698 9.0503139 5.4570312 10.75 L 2.8535156 8.1464844 C 2.7560156 8.0489844 2.628 8 2.5 8 z" />
        </svg>
    ),
    redo: (color, style) => (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            style={{ ...style, fill: color || '' }}
        >
            <path d="M 11.5 8 C 7.257 8 3.6110312 10.520531 1.9570312 14.144531 C 1.7090313 14.687531 1.9847813 15.328578 2.5507812 15.517578 C 3.0297813 15.677578 3.5527188 15.452188 3.7617188 14.992188 C 5.0977187 12.048188 8.057 10 11.5 10 C 13.678099 10 15.656912 10.829684 17.160156 12.177734 L 14.191406 15.146484 C 13.996406 15.341484 13.996406 15.658516 14.191406 15.853516 C 14.289406 15.950516 14.416922 16 14.544922 16 L 21.044922 16 A 1 1 0 0 0 22.044922 15 L 22.044922 8.5 C 22.044922 8.372 21.996437 8.2434844 21.898438 8.1464844 C 21.703437 7.9514844 21.386406 7.9514844 21.191406 8.1464844 L 18.568359 10.769531 C 16.705156 9.0570281 14.232024 8 11.5 8 z" />
        </svg>
    ),

    twilio: (color, style) => (
        <svg
            width="2500"
            height="2500"
            viewBox="0 0 256 256"
            style={{ ...style, fill: color || '' }}
            xmlns="http://www.w3.org/2000/svg"
            preserveAspectRatio="xMidYMid"
        >
            {/* <g fill="#5E8EA4"> */}
            <path d="M127.86 222.304c-52.005 0-94.164-42.159-94.164-94.163 0-52.005 42.159-94.163 94.164-94.163 52.004 0 94.162 42.158 94.162 94.163 0 52.004-42.158 94.163-94.162 94.163zm0-222.023C57.245.281 0 57.527 0 128.141 0 198.756 57.245 256 127.86 256c70.614 0 127.859-57.244 127.859-127.859 0-70.614-57.245-127.86-127.86-127.86z" />
            <path d="M133.116 96.297c0-14.682 11.903-26.585 26.586-26.585 14.683 0 26.585 11.903 26.585 26.585 0 14.684-11.902 26.586-26.585 26.586-14.683 0-26.586-11.902-26.586-26.586M133.116 159.983c0-14.682 11.903-26.586 26.586-26.586 14.683 0 26.585 11.904 26.585 26.586 0 14.683-11.902 26.586-26.585 26.586-14.683 0-26.586-11.903-26.586-26.586M69.431 159.983c0-14.682 11.904-26.586 26.586-26.586 14.683 0 26.586 11.904 26.586 26.586 0 14.683-11.903 26.586-26.586 26.586-14.682 0-26.586-11.903-26.586-26.586M69.431 96.298c0-14.683 11.904-26.585 26.586-26.585 14.683 0 26.586 11.902 26.586 26.585 0 14.684-11.903 26.586-26.586 26.586-14.682 0-26.586-11.902-26.586-26.586" />
            {/* </g> */}
        </svg>
    ),
};

export default svgLib;
